import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

const TypeDetailModal = ({ show, onHide, type }) => {
  if (!type) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Vehicle Type Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Vehicle Details */}
        <h5 className="mb-3">Vehicle Details</h5>

        <Row className="g-3">
          {/* Vehicle Company */}
          <Col md={6}>
            <div>
              <strong>Vehicle Company</strong>
              <div>{type.company ?? "-"}</div>
            </div>
          </Col>

          {/* Vehicle Type */}
          <Col md={6}>
            <div>
              <strong>Vehicle Type</strong>
              <div>{type.vehiclename ?? "-"}</div>
            </div>
          </Col>

          {/* Wheeler Type */}
          <Col md={6}>
            <div>
              <strong>Wheeler Type</strong>
              <div>{type.vehicle_type ?? "-"}</div>
            </div>
          </Col>

          {/* Vehicle Category */}
          <Col md={6}>
            <div>
              <strong>Vehicle Category</strong>
              <div>{type.vehicleCategory ?? "-"}</div>
            </div>
          </Col>

          {/* Battery */}
          <Col md={6}>
            <div>
              <strong>Battery</strong>
              <div>{type.battery != null ? `${type.battery} KWH` : "-"}</div>
            </div>
          </Col>

          {/* Feet */}
          <Col md={6}>
            <div>
              <strong>Feet</strong>
              <div>{type.feet ?? "-"}</div>
            </div>
          </Col>

          {/* Service Interval KM */}
          <Col md={6}>
            <div>
              <strong>First Service Interval Km</strong>
              <div>
                {type.firstServiceKm != null
                  ? `${type.firstServiceKm} Km`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval Days */}
          <Col md={6}>
            <div>
              <strong>First Service Interval Days</strong>
              <div>
                {type.firstServiceDays != null
                  ? `${type.firstServiceDays} Days`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval KM */}
          <Col md={6}>
            <div>
              <strong>Second Service Interval Km</strong>
              <div>
                {type.secondServiceKm != null
                  ? `${type.secondServiceKm} Km`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval Days */}
          <Col md={6}>
            <div>
              <strong>Second Service Interval Days</strong>
              <div>
                {type.secondServiceDays != null
                  ? `${type.secondServiceDays} Days`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval KM */}
          <Col md={6}>
            <div>
              <strong>Third Service Interval Km</strong>
              <div>
                {type.thirdServiceKm != null
                  ? `${type.thirdServiceKm} Km`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval Days */}
          <Col md={6}>
            <div>
              <strong>Third Service Interval Days</strong>
              <div>
                {type.thirdServiceDays != null
                  ? `${type.thirdServiceDays} Days`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval KM */}
          <Col md={6}>
            <div>
              <strong>Fixed Service Interval Km</strong>
              <div>
                {type.fixedServiceKm != null
                  ? `${type.fixedServiceKm} Km`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Service Interval Days */}
          <Col md={6}>
            <div>
              <strong>Fixed Service Interval Days</strong>
              <div>
                {type.fixedServiceDays != null
                  ? `${type.fixedServiceDays} Days`
                  : "-"}
              </div>
            </div>
          </Col>

          {/* Amount */}
          <Col md={6}>
            <div>
              <strong>Amount (Per Unit)</strong>
              <div>{type.amount != null ? `₹ ${type.amount}` : "-"}</div>
            </div>
          </Col>
        </Row>

        {/* OEM Details */}
        <hr className="my-4" />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">OEM Details</h5>

          <span className="badge bg-primary">
            {type.oemDetails?.length || 0} OEM
            {type.oemDetails?.length === 1 ? "" : "s"}
          </span>
        </div>

        {type.oemDetails && type.oemDetails.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "8%" }}>#</th>
                  <th>OEM Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                </tr>
              </thead>

              <tbody>
                {type.oemDetails.map((oem, index) => (
                  <tr key={oem._id || index}>
                    <td>{index + 1}</td>

                    <td>{oem.name ?? oem.Name ?? "-"}</td>

                    <td>{oem.contact ?? oem.Contact ?? "-"}</td>

                    <td>{oem.email ?? oem.Email ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-muted text-center border rounded p-3">
            No OEM details available
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TypeDetailModal;
